import React from "react";
import { Card, List, Row, Col, Typography, Progress, Button, Badge, Avatar, Empty } from "antd";
import { TeamOutlined, UserOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { baseImageUrl } from "Common/Components/baseImageUrl";

const { Title, Text } = Typography;

const AllLearners = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { learners = [], darkMode = false } = location.state || {};

  const getStatus = (progress) => {
    if (progress < 50) return "needs-attention";
    if (progress >= 90) return "near-completion";
    return "active";
  };

  return (
    <Card
      title={
        <span style={{ color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined }}>
          <TeamOutlined style={{ marginRight: 8 }} /> Your Learners
        </span>
      }
      style={{
        borderRadius: 12,
        marginBottom: 24,
        backgroundColor: darkMode ? "#1f1f1f" : "#fff",
        borderColor: darkMode ? "#303030" : "#f0f0f0",
      }}
      extra={
        <Button type="default" onClick={() => navigate(-1)}>
          Back
        </Button>
      }
    >
      {learners.length === 0 ? (
        <Empty
          description={
            <Text style={{ color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)" }}>
              No Learners Available
            </Text>
          }
          style={{
            padding: 40,
            backgroundColor: darkMode ? "#2a2a2a" : "#fafafa",
            borderRadius: 8,
          }}
        />
      ) : (
        <List
          grid={{ gutter: 16, xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
          dataSource={learners}
          renderItem={(learner) => {
            const status = getStatus(learner.progress);
            return (
              <List.Item>
                <Card
                  hoverable
                  style={{
                    backgroundColor: darkMode ? "#2a2a2a" : "#fff",
                    borderColor: darkMode ? "#404040" : "#f0f0f0",
                    transition: "all 0.3s",
                  }}
                >
                  <Row gutter={16} align="middle">
                    <Col xs={6}>
                      <Badge
                        dot
                        color={
                          status === "needs-attention"
                            ? "#ff4d4f"
                            : status === "near-completion"
                            ? "#52c41a"
                            : "#9A6B0E"
                        }
                      >
                        <Avatar
                          size={64}
                          src={
                            learner.profileImage ? `${baseImageUrl}${learner.profileImage}` : null
                          }
                          icon={!learner?.profileImage && <UserOutlined />}
                        />
                      </Badge>
                    </Col>
                    <Col xs={18}>
                      <Title
                        level={5}
                        style={{
                          marginBottom: 4,
                          color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
                        }}
                      >
                        {learner.firstName} {learner.lastName}
                      </Title>
                      <Progress
                        percent={learner.progress}
                        strokeColor={
                          status === "needs-attention"
                            ? "#ff4d4f"
                            : status === "near-completion"
                            ? "#52c41a"
                            : "#9A6B0E"
                        }
                        showInfo={false}
                      />
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <Text
                          type="secondary"
                          style={{
                            color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)",
                          }}
                        >
                          {learner.progress}% complete
                        </Text>

                        <Button
                          type="link"
                          size="small"
                          style={{
                            paddingLeft: 0,
                            color: status === "needs-attention" ? "#ff4d4f" : undefined,
                          }}
                        >
                          {status === "needs-attention"
                            ? "Needs attention"
                            : status === "near-completion"
                            ? "Near completion"
                            : "On track"}
                        </Button>
                      </div>
                      <Text
                        type="secondary"
                        style={{
                          color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)",
                        }}
                      >
                        Business Group: {learner.businessGroupName}
                      </Text>
                    </Col>
                  </Row>
                </Card>
              </List.Item>
            );
          }}
        />
      )}
    </Card>
  );
};

export default AllLearners;
